export class Url {
  constructor(public organizationId: number) {}

  adsPath() {
    return `/${this.organizationId}/ads`;
  }

  newAdPath() {
    return `/${this.organizationId}/ads/new`;
  }

  adPath(id: string) {
    return `/${this.organizationId}/ads/${id}`;
  }

  editAdPath(id: string) {
    return `/${this.organizationId}/ads/${id}/edit`;
  }

  payoutsPath() {
    return `/${this.organizationId}/payments`;
  }

  payoutPendingPath() {
    return `/${this.organizationId}/payments/pending`;
  }

  payoutShowPath(payoutId: string) {
    return `/${this.organizationId}/payments/${payoutId}`;
  }

  payoutDownloadCSVPath(payoutId: string) {
    return `/${this.organizationId}/payments/export_payment_history?id=${payoutId}`;
  }

  payoutHistoryDownloadCSVPath() {
    return `/${this.organizationId}/payments/export_payment_history`;
  }

  appPath(appId: string) {
    return `/${this.organizationId}/apps/${appId}`;
  }

  settingsPath() {
    return `/${this.organizationId}/settings`;
  }

  adBillingSettingsPath() {
    return `/${this.organizationId}/settings/ad_billing`;
  }

  billsPath() {
    return `/${this.organizationId}/settings/ad_billing/bills`;
  }
}
